import { useEffect } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useBasket } from "../context/BasketContext";

export const BasketSync = () => {
  const { isMember } = useAuth();
  const { items } = useBasket();

  useEffect(() => {
    if (!isMember) return;
    const t = setTimeout(() => {
      api.post("/basket/sync", {
        items: items.map((i) => ({ deal_id: i.deal_id, slug: i.slug, title: i.title, qty: i.qty, price: i.price })),
      }).catch(() => {});
    }, 1000);
    return () => clearTimeout(t);
  }, [items, isMember]);

  return null;
};
